module.exports = __webpack_public_path__ + "static/media/drive_moto1.a0e0f1f4.jpg";